import React, { PropsWithChildren } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface VerificationPageLayoutProps extends PropsWithChildren {
    title: string;
}

const VerificationPageLayout: React.FC<VerificationPageLayoutProps> = ({ title, children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <Box
            sx={{
                backgroundColor: '#FEFBFF',
                minHeight: isSmallScreen ? 'calc(100vh - 96px)' : '100vh',
                position: isSmallScreen ? 'absolute' : 'relative',
                top: isSmallScreen ? '86px' : 'auto',
                left: isSmallScreen ? '0' : 'auto',
                right: isSmallScreen ? '0' : 'auto',
                bottom: isSmallScreen ? '0' : 'auto',
                padding: 2, // 16px
                paddingBottom: isSmallScreen ? 4 : 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                width: isSmallScreen ? '100vw' : '100%',
                boxSizing: 'border-box',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: isMobile ? 2 : 4, // 16px or 32px
                    paddingBottom: isSmallScreen ? 3 : 2,
                    width: '100%',
                    maxWidth: '100%',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    marginBottom: isSmallScreen ? 2 : 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        mb: isMobile ? 2 : 3,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            color: '#132F5F',
                            textAlign: 'left',
                            fontSize: isMobile ? '1.1rem' : '1.4rem',
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                {children}
            </Box>
        </Box>
    );
};

export default VerificationPageLayout;
